import { Dialog } from '@progress/kendo-react-dialogs';
import { Tree, TreeProps } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import useStyles from '../../../../asite-relatics/styles/useStyles';

interface FolderTreeWithInputDataProps {
    pathList?: string[];
    newFolderModalVisible: boolean;
    setNewFolderModalVisible: (value: boolean) => void;
    setSelectedPath: (value: any) => void;
}

function markLeaf(arr: any) {
    arr.forEach((item: any) => {
        if (item.children.length > 0) {
            markLeaf(item.children);
        } else {
            item.disabled = false;
        }
    });
}

function makeTreeFromPathList(pathList: any[] | undefined, result: any) {
    let level: any = { result };

    pathList?.sort((a, b) => {
        const aSlashes = a?.targetFolder?.fullPath?.split('/').length;
        const bSlashes = b?.targetFolder?.fullPath?.split('/').length;
        return aSlashes - bSlashes;
    });

    pathList?.forEach((path) => {
        path?.targetFolder?.fullPath?.split('/').reduce((r: any, name: any, i: any, a: any) => {
            if (!r[name]) {
                r[name] = { result: [] };
                r.result.push({
                    title: name,
                    children: r[name].result,
                    disabled: !Boolean(i === a.length - 1),
                    fullPath: path?.targetFolder?.fullPath,
                    folderId: path?.targetFolderId,
                    workspaceId: path?.targetWorkspaceId,
                    workspaceName: path?.targetFolder?.fullPath?.split('/')[0],
                });
            }
            return r[name];
        }, level);
    });
}

const FolderTreeWithInputData: React.FC<FolderTreeWithInputDataProps> = ({
    pathList,
    newFolderModalVisible,
    setNewFolderModalVisible,
    setSelectedPath,
}) => {
    const [treeData, setTreeData] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        let result: any = [];
        makeTreeFromPathList(pathList, result);
        markLeaf(result);
        setTreeData(result);
    }, []);

    const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
        setSelectedPath(info.node);
    };

    return (
        <Fragment>
            {newFolderModalVisible && (
                <Dialog
                    title={'Select placeholder path'}
                    onClose={() => {
                        setNewFolderModalVisible(!newFolderModalVisible);
                    }}
                    width={'30%'}
                    className={classes.dialog}
                >
                    <Tree defaultExpandAll treeData={treeData} onSelect={onSelect} />
                </Dialog>
            )}
        </Fragment>
    );
};

export default FolderTreeWithInputData;
